module.exports = __webpack_public_path__ + "static/media/free-mobile-security.0db45a21.png";